"use strict";

import angular from "angular";

import { ContractPermission } from "../../presentation/services/ContractPermission/ContractPermission";

const name = "contractPermission";
const factory = [
    "$timeout",
    ($timeout) => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const ContractPermissionService = new ContractPermission();
            const contractPermission = $attr.contractPermission;
            const _contractPermission = JSON.parse(`${contractPermission}`);
            if (
                !_contractPermission.module ||
                !_contractPermission.contract ||
                !_contractPermission.source
            )
                return true;
            const modulePermission = ContractPermissionService.hideModuleBySource(
                _contractPermission
            );
            if (!modulePermission.sourceContracted && modulePermission.hide)
                $elem.remove();
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
